import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class ConfigActions extends Actions{
    static get target(){
        return 'config'
    }

    static append(data){
        super.set({
            ...store.getState().config || {},
            ...data
        })
    }
}


// WEBPACK FOOTER //
// ./actions/ConfigActions.js